import type { FileSourceData } from "./stores/diff";

/**
 * Read a single browser File into our normalized FileSourceData shape.
 * Browser-only utility; safe to import from apps/web.
 */
export async function fileToSourceData(f: File): Promise<FileSourceData> {
  const bytes = new Uint8Array(await f.arrayBuffer());
  return { bytes, name: f.name };
}

/**
 * Wrap a raw text string (e.g., from a paste textarea) as a FileSourceData.
 * The encoding step in the worker will detect it as UTF-8.
 */
export function textToSourceData(text: string, name = "(pasted)"): FileSourceData {
  return { bytes: new TextEncoder().encode(text), name };
}
